import * as Yup from 'yup';

export const passwordText =
  'Password must contain lowercase letter, uppercase letter, and a number';

const passwordSchema = () =>
  Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/, passwordText);

export default Yup.object().shape({
  password: passwordSchema(),
  password2: passwordSchema().oneOf([Yup.ref('password'), null], 'Passwords must match'),
  question: Yup.string().required('Security Question is required').min(5),
  answer: Yup.string().required('Security Answer is required').min(5),
});
